/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getListingDetails} from '../api'

 export const useQueryGetListingDetails = createReactQueryHook('getListingDetails', getListingDetails)
